import slideToggle from "./helpers/slide-toggle";
import formHelper from "./helpers/formHelper";
import _modalComponent from "./modules/_modalComponent";
import scrollTo from "./modules/_scrollto";

"use_strict";

document.addEventListener( 'DOMContentLoaded', () => {

// Отключение focus при клике мышю
    const removeActive = ( tagType ) => {
        const tag = document.querySelectorAll(tagType);
        tag.forEach(item => {
            item.addEventListener('mousedown', e => e.preventDefault())
        });
    }

    removeActive('button');
    removeActive('a');

    function actualResizeHandler() {

        const header = document.querySelector('.header-new');
        const heightHeader = header.clientHeight;

        document.body.style.paddingTop = heightHeader + "px";

        if (document.body.classList.contains('admin-bar')) {
            const adminBarHeight = document.querySelector('#wpadminbar').clientHeight;
            header.style.top = adminBarHeight + 'px';
        }

    }

    actualResizeHandler();

    function openMenu() {

        const openMenuBtn = document.querySelector('#menu-toggle');
        const menu = document.querySelector('#mob-menu');

        if (!openMenuBtn) return;

        openMenuBtn.addEventListener('click', function () {
            this.classList.toggle('open');
            document.body.classList.toggle('no-scroll')
            slideToggle(menu);
        });
    }

    openMenu();

    function openSubMenu() {

        const hasChildrenItem = document.querySelectorAll('.mob-menu .menu-item.menu-item-has-children>a');

        hasChildrenItem.forEach(target => {

            const parentTarget = target.parentElement;

            target.nextElementSibling.style.display = 'none';

            target.addEventListener('click', function (e) {
                e.preventDefault();

                this.parentElement.classList.toggle('open');
                slideToggle(this.nextElementSibling);
            });

        });
    }

    openSubMenu();

    formHelper('.wpcf7-form');
    _modalComponent();
    scrollTo();
});